// AgentAvatar.jsx -- Unique SVG avatar per agent
// ASCII only. var declarations. ESM only. Inline styles only.

var AGENT_ICONS = {
  // Engineering
  'agent_engineering_manager': { color: '#6366F1', icon: 'kanban' },
  'agent_cracked':             { color: '#6366F1', icon: 'bolt' },
  'agent_evolver':             { color: '#10B981', icon: 'refresh' },
  'agent_qa_verifier':         { color: '#6366F1', icon: 'check-shield' },
  'agent_hc_builder':          { color: '#6366F1', icon: 'kanban' },

  // Finance
  'agent_cfo':                 { color: '#EF4444', icon: 'chart' },
  'agent_bookkeeper':          { color: '#10B981', icon: 'ledger' },
  'agent_collections':         { color: '#D97706', icon: 'gavel' },
  'agent_payroll':             { color: '#D97706', icon: 'dollar' },
  'agent_cpa':                 { color: '#6B7280', icon: 'calculator' },
  'agent_saas_zero':           { color: '#10B981', icon: 'scissors' },

  // Growth / Revenue
  'agent_sales_director':      { color: '#4F6EF7', icon: 'target' },
  'agent_sdr':                 { color: '#3B82F6', icon: 'megaphone' },
  'agent_customer_success':    { color: '#F59E0B', icon: 'heart' },
  'agent_account_manager':     { color: '#10B981', icon: 'user' },
  'agent_fundraise':           { color: '#EF4444', icon: 'trending' },
  'agent_ir':                  { color: '#4F6EF7', icon: 'bar' },
  'agent_networking':          { color: '#8B5CF6', icon: 'network' },
  'agent_pitch_deck':          { color: '#8B5CF6', icon: 'slides' },
  'agent_growth':              { color: '#10B981', icon: 'trending' },
  'agent_storefront_scout':    { color: '#F59E0B', icon: 'eye' },

  // Core Operations
  'agent_coo':                 { color: '#64748B', icon: 'gear' },
  'agent_chief_of_staff':      { color: '#8B5CF6', icon: 'clipboard' },
  'agent_governance':          { color: '#6B7280', icon: 'scale' },
  'agent_org_admin':           { color: '#6B7280', icon: 'gear' },

  // Infrastructure
  'agent_connector':           { color: '#3B82F6', icon: 'plug' },
  'agent_upgrade':             { color: '#8B5CF6', icon: 'arrow-up' },

  // Legal
  'agent_fund_counsel':        { color: '#6B7280', icon: 'scale' },
  'agent_contract':            { color: '#6B7280', icon: 'file' },

  // People / HR
  'agent_people_hr':           { color: '#EC4899', icon: 'heart' },

  // Content
  'agent_narrative':           { color: '#EC4899', icon: 'pen' },
  'agent_content':             { color: '#EC4899', icon: 'pen' },
  'agent_gtm':                 { color: '#F59E0B', icon: 'rocket' },

  // Communication
  'agent_call':                { color: '#3B82F6', icon: 'phone' },
  'agent_calendar':            { color: '#3B82F6', icon: 'calendar' },

  // Security
  'agent_security_monitor':    { color: '#EF4444', icon: 'shield-alert' },
  'security':                  { color: '#EF4444', icon: 'shield' },

  // System
  'agent_hub':                 { color: '#4F6EF7', icon: 'sparkle' },
  'agent_hc_auditor':          { color: '#6B7280', icon: 'eye' },
  'agent_domain_search':       { color: '#3B82F6', icon: 'target' },
  'agent_synthesizer':         { color: '#4F6EF7', icon: 'sparkle' },
  'agent_triage':              { color: '#8B8FA3', icon: 'inbox' },

  // Clones
  'agent_aaron_clone':         { color: '#4F6EF7', icon: 'user-clone' },
  'agent_clayton_clone':       { color: '#4F6EF7', icon: 'user-clone' },

  // Shadow agents
  'shadow_claude':             { color: '#8B5CF6', icon: 'eye' },
  'shadow_gemini':             { color: '#3B82F6', icon: 'eye' },
  'shadow_gpt':                { color: '#10B981', icon: 'eye' },
  'shadow_perplexity':         { color: '#F59E0B', icon: 'eye' },

  // Legacy / may be inactive
  'agent_qa':                  { color: '#6366F1', icon: 'check-shield' },
  'agent_project_manager':     { color: '#06B6D4', icon: 'kanban' },
};

function getAgentMeta(agentId) {
  return AGENT_ICONS[agentId] || { color: '#4F6EF7', icon: 'circle' };
}

function IconPath(props) {
  var name = props.name;
  switch (name) {
    case 'chart':      return (
      <>
        <path d="M3 3v18h18" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M7 16l4-6 4 4 5-8" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'gavel':      return (
      <>
        <path d="M14.5 3.5l6 6M3 21l4-4" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <rect x="8" y="5" width="8" height="8" rx="1" transform="rotate(45 12 9)" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'ledger':     return (
      <>
        <rect x="4" y="3" width="16" height="18" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="4" y1="9" x2="20" y2="9" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="10" y1="9" x2="10" y2="21" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'target':     return (
      <>
        <circle cx="12" cy="12" r="9" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="12" cy="12" r="5" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="12" cy="12" r="1" fill="currentColor"/>
      </>
    );
    case 'megaphone':  return (
      <path d="M18 8a3 3 0 013 3v2a3 3 0 01-3 3M4 9h2l8-5v16l-8-5H4a1 1 0 01-1-1v-4a1 1 0 011-1z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'shield':     return (
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'clipboard':  return (
      <>
        <rect x="5" y="2" width="14" height="20" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="9" y1="10" x2="15" y2="10" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="9" y1="14" x2="15" y2="14" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'scale':      return (
      <path d="M12 3v18M3 7l9-4 9 4M5 7l-2 8h6L7 7M17 7l-2 8h6l-2-8" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'bolt':       return (
      <polygon points="13,2 3,14 12,14 11,22 21,10 12,10" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'inbox':      return (
      <>
        <polyline points="22,12 16,12 14,15 10,15 8,12 2,12" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'gear':       return (
      <>
        <circle cx="12" cy="12" r="3" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'heart':      return (
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'folder':     return (
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'trending':   return (
      <>
        <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <polyline points="17,6 23,6 23,12" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'network':    return (
      <>
        <circle cx="12" cy="5" r="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="5" cy="19" r="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="19" cy="19" r="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="12" y1="7" x2="5" y2="17" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="12" y1="7" x2="19" y2="17" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'phone':      return (
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.69 12 19.79 19.79 0 011.61 3.4 2 2 0 013.6 1.22h3a2 2 0 012 1.72c.24.96.55 1.9.7 2.81a2 2 0 01-.45 2.11L7.91 9.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.91.15 1.85.46 2.81.7A2 2 0 0122 16.92z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'sparkle':    return (
      <path d="M12 2l2 7h7l-5.5 4 2 7L12 16l-5.5 4 2-7L3 9h7z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'refresh':    return (
      <>
        <polyline points="23,4 23,10 17,10" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <polyline points="1,20 1,14 7,14" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'dollar':     return (
      <>
        <line x1="12" y1="1" x2="12" y2="23" strokeWidth="1.5" stroke="currentColor"/>
        <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'calendar':   return (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="16" y1="2" x2="16" y2="6" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="8" y1="2" x2="8" y2="6" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="3" y1="10" x2="21" y2="10" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'calculator': return (
      <>
        <rect x="4" y="2" width="16" height="20" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="8" y1="6" x2="16" y2="6" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="8" y1="10" x2="8" y2="10.01" strokeWidth="2" stroke="currentColor"/>
        <line x1="12" y1="10" x2="12" y2="10.01" strokeWidth="2" stroke="currentColor"/>
        <line x1="16" y1="10" x2="16" y2="10.01" strokeWidth="2" stroke="currentColor"/>
        <line x1="8" y1="14" x2="8" y2="14.01" strokeWidth="2" stroke="currentColor"/>
        <line x1="12" y1="14" x2="12" y2="14.01" strokeWidth="2" stroke="currentColor"/>
        <line x1="16" y1="14" x2="16" y2="14.01" strokeWidth="2" stroke="currentColor"/>
      </>
    );
    case 'pen':        return (
      <path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
    );
    case 'rocket':     return (
      <>
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09zM12 15l-3-3" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M22 2l-7.5 7.5" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M9.5 8L4 14l6.5 6.5L17 15.5" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'bar':        return (
      <>
        <line x1="18" y1="20" x2="18" y2="10" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="12" y1="20" x2="12" y2="4" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="6" y1="20" x2="6" y2="14" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'user':       return (
      <>
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="12" cy="7" r="4" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'slides':     return (
      <>
        <rect x="2" y="3" width="20" height="14" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="8" y1="21" x2="16" y2="21" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="12" y1="17" x2="12" y2="21" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'file':       return (
      <>
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <polyline points="14,2 14,8 20,8" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'scissors':   return (
      <>
        <circle cx="6" cy="6" r="3" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="6" cy="18" r="3" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="20" y1="4" x2="8.5" y2="15.5" strokeWidth="1.5" stroke="currentColor"/>
        <line x1="20" y1="20" x2="8.5" y2="8.5" strokeWidth="1.5" stroke="currentColor"/>
      </>
    );
    case 'kanban':     return (
      <>
        <rect x="3" y="3" width="5" height="18" rx="1" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <rect x="10" y="3" width="5" height="12" rx="1" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <rect x="17" y="3" width="5" height="15" rx="1" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'check-shield': return (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M9 12l2 2 4-4" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'shield-alert': return (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <line x1="12" y1="9" x2="12" y2="13" strokeWidth="1.5" stroke="currentColor"/>
        <circle cx="12" cy="16" r="0.5" fill="currentColor"/>
      </>
    );
    case 'plug':       return (
      <>
        <path d="M12 22v-6" strokeWidth="1.5" stroke="currentColor"/>
        <path d="M7 16h10" strokeWidth="1.5" stroke="currentColor"/>
        <path d="M8 2v6M16 2v6" strokeWidth="1.5" stroke="currentColor"/>
        <rect x="6" y="8" width="12" height="8" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'eye':        return (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="12" cy="12" r="3" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'arrow-up':   return (
      <>
        <line x1="12" y1="19" x2="12" y2="5" strokeWidth="1.5" stroke="currentColor"/>
        <polyline points="5,12 12,5 19,12" strokeWidth="1.5" stroke="currentColor" fill="none"/>
      </>
    );
    case 'user-clone': return (
      <>
        <circle cx="10" cy="8" r="4" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M2 20c0-4 3.6-7 8-7s8 3 8 7" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="17" cy="8" r="3" strokeWidth="1.2" stroke="currentColor" fill="none" opacity="0.4"/>
      </>
    );
    case 'lock':       return (
      <>
        <rect x="5" y="11" width="14" height="10" rx="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <path d="M8 11V7a4 4 0 018 0v4" strokeWidth="1.5" stroke="currentColor" fill="none"/>
        <circle cx="12" cy="16" r="1" fill="currentColor"/>
      </>
    );
    default:           return <circle cx="12" cy="12" r="6" strokeWidth="1.5" stroke="currentColor" fill="none"/>;
  }
}

export function getAgentColor(agentId) {
  return getAgentMeta(agentId).color;
}

export default function AgentAvatar(props) {
  var agentId = props.agentId || '';
  var size = props.size || 28;
  var animated = props.animated || false;
  var meta = getAgentMeta(agentId);

  var containerStyle = {
    width: size, height: size, borderRadius: 8,
    background: meta.color + '18',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    cursor: animated ? 'pointer' : 'default'
  };

  return (
    <div style={containerStyle}
      onMouseEnter={animated ? function(e) { e.currentTarget.style.transform = 'scale(1.08)'; e.currentTarget.style.boxShadow = '0 2px 8px ' + meta.color + '30'; } : undefined}
      onMouseLeave={animated ? function(e) { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = 'none'; } : undefined}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24"
        fill="none" style={{ color: meta.color }}>
        <IconPath name={meta.icon} />
      </svg>
    </div>
  );
}
